import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import OrganizationDetailPage from '@features/admin/organizations/OrganizationDetailPage.tsx';
import { useAdminOrganizationDetailStore } from '@features/admin/organizations/useAdminOrganizationDetailStore.ts';

const paramsSchema = z.object({
  organizationId: z.coerce.number().positive(),
});

const searchSchema = z.object({
  userQuery: z.string().optional(),
  passwordFilter: z.enum(['all', 'has', 'none']).optional(),
  userPage: z.coerce.number().optional(),
});

export const Route = createFileRoute('/admin/organizations/$organizationId/')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ({ params }) => {
    const organizationId = paramsSchema.parse(params).organizationId;
    useAdminOrganizationDetailStore.getState().loadOrganizationDetail(organizationId);
  },
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  return <OrganizationDetailPage organizationId={organizationId} />;
}
